<template>
  <main>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </main>
  <Slideout :id="slideout?.id" :title="slideout?.title" v-bind="slideout?.slideoutAction" @close-slideout="closeSlideout(slideout)">
    <component
      :is="slideout?.component"
      v-if="slideout?.component"
      v-bind="slideout?.props"
      @footer-action="(buttonDetails) => slideoutFooterAction(buttonDetails)"
    />
    <template #footer>
      <AppButton v-if="slideout?.footer" v-bind="slideout?.footer">
        {{ slideout?.footer.title }}
      </AppButton>
      <button
        v-if="footerButton"
        class="primary button expanded"
        :disabled="footerButton?.disabled"
        @click="footerButton?.action"
        @keydown.enter.prevent="footerButton?.action"
        v-text="footerButton?.label"
      ></button>
    </template>
  </Slideout>
  <ModalOverlay :id="modal.id" :title="modal.title" :width="modal.width" @close="closeModal">
    <template #body>
      <component :is="modal.component" v-show="modal.component" v-bind="modal.props" />
    </template>
  </ModalOverlay>
  <ProductQuickviewSlideout v-bind="productQuickviewProps" />
</template>

<script setup>
import { onMounted } from 'vue';
import Slideout from '@atomic-ui/slideout/Slideout';
import ModalOverlay from '@atomic-ui/modalOverlay/ModalOverlay';
import { useSlideout } from '~/composables/useSlideout';
import { useModal } from '~/composables/useModal';
import { loadTagLibrary } from '@vue-util/tagManager';
import { useEnvPropsStore } from '@/stores/useEnvPropsStore';
import { headLinks } from '@/utils/headLinks';

const { slideout } = useSlideout();
const { modal } = useModal();
const envPropsStore = useEnvPropsStore();
const footerButton = ref(null);

useHead({ link: headLinks });

const ProductQuickviewSlideout = defineAsyncComponent(
  () => import(/* webpackChunkName: 'ProductQuickviewSlideout' */ '@nuxt-common/product-quickview/app/components/ProductQuickviewSlideout'),
);

const productQuickviewProps = {
  pageType: 'pdp',
  tagging: {},
};

onMounted(() => {
  loadTagLibrary(import.meta.env.VITE_ENTRY_POINT, envPropsStore.envProps?.tagManagerEnv, true);
});

//TODO: will see this code is required or not in future when we will implement tagging.
// Fire tag when return shipping fee modal close.
const closeModal = () => {
  // if (id === 'return-shipping-fee') {
  //   fireTag('link', {
  //     event_name: 'return fee popup',
  //     custom_link_name: 'return fee popup_closed',
  //   });
  // }
};

const closeSlideout = (options) => {
  footerButton.value = null; // we need to reset footer action everytime
  if (options.focusAction) {
    options.focusAction();
    return;
  }
  if (options.elementIdToFocus) {
    document.getElementById(options.elementIdToFocus)?.focus();
  }
};

const slideoutFooterAction = (buttonDetails) => {
  footerButton.value = buttonDetails;
};
</script>
